import * as React from "react";
import classNames from 'classnames';
import {IAttrs} from "~/utils/types/IAttrs";
import {isArr, isNotBlankString} from "~/ok/utils/type";

type ServicesProp = string | string[] | undefined | null;
interface IProps {
    services?: ServicesProp;
    attrs?: IAttrs;
    className?: string | string[];
    children?: React.ReactNode
}


// Для удаления обсервера с ноды, см mres/js/alf/cardReadTracking.js#11
interface PatchedHTMLElement extends HTMLDivElement {
    okTrackerUnobserve?: () => void;
}

/**
 * !!!WARNING!!!
 * Компонент создаёт дополнительный <div> в DOM-дереве.
 * Если нужен только функционал инициализации сервисов - используй хук ниже `useServicesInit`
 *
 * Компонент обертка для запуска сервисов или behaviors
 * @param services имя сервиса, который будет запущен на обертке при маунте
 */
export const ServicesInitWrapper: React.FC<IProps> = ({children, attrs, services, className}) => {
    const ref = React.useRef<PatchedHTMLElement>(null);
    const servicesStr = servicesToStr(services);

    useServicesInit(ref);

    return (
        <div ref={ref}
             {...(attrs || null)}
             className={classNames(servicesStr && "js-call", className)}
             data-services={servicesStr}
        >
            {children}
        </div>
    );
};


export const ServicesInitHtmlWrapper: React.FC<{htmlContent: string} & IProps> = ({htmlContent, attrs, services, className}) => {
    const ref = React.useRef<PatchedHTMLElement>(null);
    const servicesStr = servicesToStr(services);

    useServicesInit(ref);

    return (
        <div
            dangerouslySetInnerHTML={{__html: htmlContent}}
            ref={ref}
            {...attrs}
            className={classNames(servicesStr && "js-call", className)} data-services={servicesStr} />
    );
};


export function useServicesInit(ref: React.RefObject<HTMLElement>) {
    React.useEffect(() => {
        if (ref.current && window.OK.ServicesInit) {
            const element = ref.current as PatchedHTMLElement;
            window.OK.ServicesInit.processScope(element);

            return () => {
                if (element.okTrackerUnobserve) {
                    element.okTrackerUnobserve();
                }
            };
        }
    }, [ref]);
}


function servicesToStr(services: ServicesProp): null | string {
    if (isNotBlankString(services)) {
        return services;
    } else if (isArr(services)) {
        const result = services.join(',');
        if (isNotBlankString(result)) {
            return result;
        }
    }
    return null;
}
